import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import { useRouter } from 'hooks/useRouter';
import { useCallback } from 'react';
import { useToast } from '@chakra-ui/react';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { ERROR_TOAST_DEFAULTS } from '@helpers';

export const useFetchBlockchain = (documentName: string | null = null) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
  });

  const { query } = useRouter();

  const { teamId, folderId, documentId } = query;

  const toast = useToast();

  const { t } = useTranslation();

  const callback = useCallback(async () => {
    const { data: blob } = await client.fetchDocumentBlockchain(
      teamId as string,
      folderId as string,
      documentId as string,
    );

    const a = window.document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `Blockchain - ${documentName} - CINCEL.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }, [client, documentId, folderId, teamId, documentName]);

  const onError = useCallback(async () => {
    const msg = t(translations.ERRORS.BLOCKCHAIN_ERROR);
    toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
  }, [t, toast]);

  const fn = useQuery(
    ['fetch-blockchain', teamId, folderId, documentId],
    callback,
    {
      enabled: false,
      onError,
      retry: 0,
    },
  );

  return { ...fn };
};
